import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OgoneResponse } from '@app/core/services/financial-engine/models/ogoneResponse';
import { ScriptsUtilsService } from '@app/core/services/util/scripts-utils.service';
import { ToastrService } from 'ngx-toastr';

declare let Tokenizer: any;
@Component({
  selector: 'ap-ogone-moto',
  templateUrl: './ogone-moto.component.html',
  styleUrls: ['./ogone-moto.component.css']
})
export class OgoneMotoComponent implements OnInit {

  @Input() ogoneResponse: OgoneResponse;
  @Input() customerLanguage: string = 'EN_en'; // Default value
  @Output() receive = new EventEmitter<any>();

  tokenizer: any;
  buttonDisabled: boolean = true;

  constructor(
    private scriptService: ScriptsUtilsService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    // Load the TokenizerScript
    this.scriptService.load('tokenizer').then(() => {
      // Create a new Ogone tokenizer with customerLanguage
      this.tokenizer = new Tokenizer(
        `https://payment.${this.ogoneResponse.partialRedirectUrl}`,
        'div-hosted-moto-tokenization',
        {
          hideTokenFields: true,
          customerLanguage: this.customerLanguage
        },
      this.ogoneResponse.tokenMoto
      );
      this.tokenizer.initialize();
    });
  }

  submitForm() {
    this.tokenizer.submitTokenization().then((data) => {
      if (data.success) {
        this.receive.emit({data});
      } else {
        this.toastr.error(data.error.message);
      }
    })
  }

}
